import type { AppTokens } from '@/theme/tokens';

/**
 * A register or list amount's colour (visual contract v2 §13, TMMAPP-0154 §A 1): incoming
 * `moneyPositive`, outgoing `text`, zero `text2`. The one rule for an amount coloured outside
 * `MoneyText` (an envelope register cell, a recurring row, a forecast row); pair it with `signed`
 * so the incoming "+" shows.
 */
export function registerAmountColor(tokens: AppTokens, minor: number): string {
  return minor > 0 ? tokens.moneyPositive : minor < 0 ? tokens.text : tokens.text2;
}
